class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (this.dataset.bundle) {
        const bundleId = this.dataset.bundle;
        let bundleItems = [];
        const bundleItemsCart = document.querySelectorAll(`tr[data-lineitems][data-bundle="${bundleId}"]`);
        if (bundleItemsCart.length > 0) {
          bundleItems = JSON.parse(bundleItemsCart[0].dataset.lineitems);
        } else {
          const bundleItemsDrawer = document.querySelectorAll(`tr[data-bundle="${bundleId}"]`);
          bundleItemsDrawer.forEach((item) => bundleItems.push(item.dataset.index));
        }
        if (bundleItems.length === 0) return;
        for (let i = bundleItems.length - 1; i > 0; i--) {
          const item = bundleItems[i];
          const body = JSON.stringify({ line: item, quantity: 0 });
          await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } });
        }
        const _firstItemIndex = bundleItems[0];
        cartItems.updateQuantity(_firstItemIndex, 0);
      } else {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
      try {
        if (_compliance_sticker_id) {
          setTimeout(async () => {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            if (cart.items.some((item) => parseInt(item.id) === parseInt(_compliance_sticker_id))) {
              // prettier-ignore
              const skusToCheck = ['WGLC1', 'WGLC2', 'WGLC5', 'WGLC10S', 'WGLC15S', 'WGLC20S', 'MLC1', 'MLC2', 'MLC5', 'MLC10S', 'MLC15S', 'MLC20S', 'SLC1', 'SLC2', 'SLC5', 'SLC10S', 'SLC15S', 'SLC20S', 'BOLC1', 'BOLC2', 'BOLC5', 'BOLC10S', 'BOLC15S', 'BOLC20S', 'PLC1', 'PLC2', 'PLC5', 'PLC10S', 'PLC15S', 'PLC20S', 'SP1', 'SP2', 'SP5', 'SP10S', 'SP15S', 'SP20S', 'WGP1', 'WP2', 'WP5', 'WP10S', 'WP15S', 'WP20S', 'MP1', 'MP2', 'MP5', 'MP10S', 'MP15S', 'MP20S'];
              const skuExistsInCart = cart.items.some((item) => skusToCheck.includes(item.sku));
              if (cart.items.some((item) => parseInt(item.id) === parseInt(_compliance_sticker_id)) && !skuExistsInCart) {
                cartItems.updateQuantity(cart.items.findIndex((item) => parseInt(item.id) === parseInt(_compliance_sticker_id)) + 1, 0);
              }
            }
          }, 1000);
        }
      } catch (error) {
        console.error('Error al obtener el carrito:', error);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        let _item_count = 0;
        parsedState.items.forEach((item) => {
          if (item.options_with_values[0].name === 'Quantity') {
            _item_count += item.quantity * parseInt(item.options_with_values[0].value.slice(0, 1));
          }
        });
        verifyIPApi(_item_count);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && quantityElement && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper && cartDrawerWrapper.querySelector('.drawer__inner-empty')) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      }).catch((err) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        console.error('Error updating cart', err);
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message.split('-')[0];

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
    }
  });
};

const _cartCheckout = document.getElementById('checkout');
const _cartErrors = document.getElementById('Cart-CartErrors');

function getIP(json) {
  fetch('https://ipapi.co/' + json.ip + '/country_code/')
    .then((response) => response.text())
    .then((data) => {
      if (data != 'US') {
        // Drawer Cart
        const drawerCartCheckout = document.getElementById('CartDrawer-Checkout');
        const drawerCartErrors = document.getElementById('CartDrawer-CartErrors');
        if (drawerCartCheckout) drawerCartCheckout.disabled = true;
        if (drawerCartErrors) drawerCartErrors.innerHTML = 'Maximum for one order is 25 packs.';
        // Cart
        if (_cartCheckout) _cartCheckout.disabled = true;
        if (_cartErrors) _cartErrors.innerHTML = 'Maximum for one order is 25 packs.';
      }
    });
}

function verifyIPApi(_item_count) {
  if (_item_count >= 25) {
    fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((json) => getIP(json));
  } else {
    // Cart
    if (_cartCheckout) _cartCheckout.disabled = false;
    if (_cartErrors) _cartErrors.innerHTML = '';
  }
}

